import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";
import type { CustomIcons } from "./Icons.type";

const size: CustomIcons = {
  small: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.33331 3.15131V6.78767H4.96968"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6666 12.8483V9.21191H11.0303"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1454 6.18162C12.8381 5.31301 12.3157 4.53641 11.627 3.9243C10.9383 3.31219 10.1058 2.88451 9.20708 2.68117C8.3084 2.47783 7.37286 2.50546 6.48774 2.76148C5.60263 3.0175 4.7968 3.49357 4.14543 4.14526L1.33331 6.78768M14.6666 9.21192L11.8545 11.8543C11.2032 12.506 10.3973 12.9821 9.51222 13.2381C8.6271 13.4941 7.69156 13.5218 6.79288 13.3184C5.8942 13.1151 5.06168 12.6874 4.37299 12.0753C3.6843 11.4632 3.1619 10.6866 2.85452 9.81799"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  medium: (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 4.72693V10.1815H7.45454"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 19.2724V13.8178H16.5455"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.7182 9.2724C19.2571 7.96948 18.4735 6.80459 17.4405 5.88642C16.4075 4.96825 15.1587 4.32673 13.8106 4.02173C12.4626 3.71672 11.0593 3.75817 9.73165 4.1422C8.40398 4.52623 7.19523 5.24032 6.21818 6.21786L2 10.1815M22 13.8179L17.7818 17.7815C16.8048 18.759 15.596 19.4731 14.2684 19.8572C12.9407 20.2412 11.5374 20.2826 10.1894 19.9776C8.84133 19.6726 7.59255 19.0311 6.55952 18.1129C5.52648 17.1948 4.74288 16.0299 4.28182 14.7269"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  large: (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.66669 6.30255V13.5753H9.93941"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M29.3333 25.6965V18.4238H22.0606"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.2909 12.3632C25.6762 10.626 24.6314 9.07279 23.254 7.84857C21.8766 6.62434 20.2116 5.76899 18.4142 5.36231C16.6169 4.95564 14.7458 5.0109 12.9755 5.52294C11.2053 6.03498 9.59365 6.98711 8.29093 8.29049L2.66669 13.5753M29.3334 18.4238L23.7091 23.7087C22.4064 25.012 20.7947 25.9642 19.0245 26.4762C17.2543 26.9883 15.3832 27.0435 13.5858 26.6368C11.7885 26.2302 10.1234 25.3748 8.74604 24.1506C7.36867 22.9264 6.32386 21.3732 5.70911 19.6359"
        stroke="currentColor"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
};

function RefreshIcon(props: SvgIconProps) {
  const item = props.fontSize === "large" || props.fontSize === "small" ? size[props.fontSize] : size.medium;
  return <SvgIcon {...props}>{item}</SvgIcon>;
}
export default RefreshIcon;
